<div class="stock-item-rule-add-container no-select">

  <div class="widget-div">

    @if (canAddItemRuleBeViewed) {
      <app-shared-widget-container-component>
        <div title class="widget-div-heading">
          <app-display-icon
            [tooltip]="canAddItemRuleBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
            [icon]="canAddItemRuleBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>Add Item Stock Rule</div>
          <app-display-icon
            [tooltip]="tooltips.addStockItemRule"
            [icon]="icons.infoSlabCircleOutline"
            [colour]="iconColours.secondary">
          </app-display-icon>
        </div>
        <div block>
          <form [formGroup]="formAddItemRule">

            @if (formAddItemRule?.controls['prefix']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="prefix" class="required-field">Prefix</label>
                  <app-shared-custom-select
                    id="prefix"
                    (selectionChange)="onSelectTokens($event, 'prefix')"
                    [allowMultiple]="false"
                    [allowSelectAll]="false"
                    [autoSubmitOnSelect]="true"
                    [floatDropdown]="true"
                    [placeholder]="'Select prefix...'"
                    [selected]="[formAddItemRule?.controls['prefix']?.value]"
                    [setOptions]="getPrefixSuffixOptions(formAddItemRule?.controls['prefix']?.value)"
                    [showActionButtons]="false"
                    [showChips]="false"
                    [showSearchBar]="false">
                  </app-shared-custom-select>
                </div>
              </div>
            }

            @if (formAddItemRule?.controls['customPrefix'] && formAddItemRule?.controls['prefix']?.value === 'Custom') {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="customPrefix">Custom Prefix</label>
                  <input
                    [class.invalid]="formAddItemRule?.controls['customPrefix']?.errors"
                    [formControlName]="'customPrefix'"
                    [placeholder]="'Enter custom prefix'"
                    id="customPrefix"
                    type="text"/>
                </div>
              </div>
            }

            @if (formAddItemRule?.controls['suffix']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="suffix" class="required-field">Suffix</label>
                  <app-shared-custom-select
                    id="suffix"
                    (selectionChange)="onSelectTokens($event, 'suffix')"
                    [allowMultiple]="false"
                    [allowSelectAll]="false"
                    [autoSubmitOnSelect]="true"
                    [floatDropdown]="true"
                    [placeholder]="'Select suffix...'"
                    [selected]="[formAddItemRule?.controls['suffix']?.value]"
                    [setOptions]="getPrefixSuffixOptions(formAddItemRule?.controls['suffix']?.value)"
                    [showActionButtons]="false"
                    [showChips]="false"
                    [showSearchBar]="false">
                  </app-shared-custom-select>
                </div>
              </div>
            }

            @if (formAddItemRule?.controls['customSuffix'] && formAddItemRule?.controls['suffix']?.value === 'Custom') {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="customSuffix">Custom Suffix</label>
                  <input
                    [class.invalid]="formAddItemRule?.controls['customSuffix']?.errors"
                    [formControlName]="'customSuffix'"
                    [placeholder]="'Enter custom suffix'"
                    id="customSuffix"
                    type="text"/>
                </div>
              </div>
            }

            @if (formAddItemRule?.controls['digits']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="digits" class="required-field">Digits</label>
                  <input
                    [class.invalid]="formAddItemRule?.controls['digits']?.errors"
                    [formControlName]="'digits'"
                    [placeholder]="'Enter number of digits'"
                    id="digits"
                    type="number"
                    min="0"
                    max="10"/>
                </div>
              </div>
            }

            @if (formAddItemRule?.controls['manualCodeEntryDefault']) {
              <div class="form-column">
                <div class="form-control-div toggle-item">
                  <label for="manualCodeEntryDefault">Manual Stock Code Entry By Default</label>
                  <app-display-icon
                    [tooltip]="tooltips.addStockItemManualCode"
                    [icon]="icons.infoSlabCircleOutline"
                    [colour]="iconColours.secondary">
                  </app-display-icon>
                  <app-switch-ui
                    (checkedChange)="onToggleManualCodeEntryDefault($event)"
                    [ariaLabel]="'add-stock-item-manual-code-entry-default'"
                    [checked]="formAddItemRule?.controls['manualCodeEntryDefault']?.value"
                    [disabled]="canAddItemRuleBeEdited === false"
                    [size]="0.7">
                  </app-switch-ui>
                </div>
              </div>
            }

          </form>
        </div>
        <div actions class="widget-actions">
          @if (hasAddItemRuleBeenEdited) {
            <button
              type="button"
              class="action-button"
              [disabled]="canAddItemRuleBeEdited === false"
              (click)="onRevertForm('addItemRule')">
              <app-display-icon
                [colour]="canAddItemRuleBeEdited === false ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.undoChanges"
                [icon]="icons.undo">
              </app-display-icon>
            </button>
          }
          @if (canAddItemRuleBeSubmitted) {
            <button
              type="button"
              class="action-button"
              [disabled]="isAddItemRuleSubmitDisabled"
              (click)="onSubmitForm('addItemRule')">
              <app-display-icon
                [colour]="isAddItemRuleSubmitDisabled ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.saveChanges"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
            </button>
          }
        </div>
      </app-shared-widget-container-component>
    }

  </div>

  <div class="ups-container-action-bar widget-actions">
    @if (hasAddItemRuleErrors?.length > 0) {
      @for (field of hasAddItemRuleErrors; track $index) {
        <button
          type="button"
          class="error-button">
          <app-display-icon
            [colour]="iconColours.red"
            [tooltip]="field?.error"
            [icon]="icons.alertRhombusOutline">
          </app-display-icon>
        </button>
      }
    }
      <button
        [disabled]="!haveAnyEditsBeenMade"
        type="button"
        class="action-button"
        (click)="onRevertForm('all')">
        <app-display-icon
          [colour]="iconColours.secondary"
          [tooltip]="tooltips.undoAllChanges"
          [icon]="icons.undo">
        </app-display-icon>
        Undo Changes
      </button>
      <button
        [disabled]="!haveAnyEditsBeenMade"
        type="button"
        class="action-button"
        (click)="onSubmitForm('all')">
        <app-display-icon
          [colour]="iconColours.secondary"
          [tooltip]="tooltips.saveAllChanges"
          [icon]="icons.contentSaveOutline">
        </app-display-icon>
        Save All
      </button>
  </div>

</div>
